import { Controller } from "@hotwired/stimulus"

// Optimistic UI for the folder carousel. On link click, moves the active state
// to the clicked folder (ring + data-active + title) without rerendering the
// carousel, preserving its horizontal scroll position. The server-side :photos
// Turbo Frame swap loads the new folder's feed.
//
// Which folder is open is per viewer, so a broadcast that replaces one tile
// cannot carry it and renders the tile unselected. The URL knows, so a tile
// that arrives for the folder currently on screen takes the active state back.
export default class extends Controller {
  static targets = ["folder", "link", "indicator", "title"]

  folderTargetConnected(folder) {
    const link = folder.querySelector("[data-folder-carousel-target='link']")
    if (link && this.#showsCurrentFolder(link)) this.#activate(folder, link)
  }

  select(event) {
    const clickedLink = event.currentTarget
    const clickedFolder = clickedLink.closest("[data-folder-carousel-target='folder']")

    this.folderTargets.forEach(el => delete el.dataset.active)
    this.indicatorTargets.forEach(el => el.classList.remove(...RING))
    this.#activate(clickedFolder, clickedLink)

    if (this.hasTitleTarget) {
      const label = clickedLink.dataset.folderLabel
      if (label) this.titleTarget.textContent = label
    }
  }

  #activate(folder, link) {
    folder?.setAttribute("data-active", "")
    link.querySelector("[data-folder-carousel-target='indicator']")
      ?.classList.add(...RING)
  }

  #showsCurrentFolder(link) {
    const linked = new URL(link.href, location.origin).searchParams.get("folder_id")
    const current = new URLSearchParams(location.search).get("folder_id")
    return linked === current
  }
}

const RING = ["rounded-full", "ring-2", "ring-primary", "ring-offset-4", "ring-offset-surface"]
